<template>

<core-modal v-on:close="onClose" type="confirm">

	<template v-slot:head>

		Delete preset

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to delete this preset?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading">Yes</core-button>
		<core-button theme="plain" v-on:click.native="onClose">No</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		filterName: function() {

			return this.$CONSTANTS.PRESET.NAME[this.data.type]

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$store.dispatch('api/presets/delete', {
				id: this.data.preset
			}).then(function(json) {

				this.$store.commit('session/presets/set', json.presets)
				this.$store.commit('filter/' + this.filterName + '/reset')

				this.$emit('close')

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

</style>